$(document).on('click', '.cancel-form, [data-inline-edit-id]:not([type="submit"])', function (e) {
    e.preventDefault();

    toggle_form_visibility($(this).data('inlineEditId'))
});

function toggle_form_visibility(id) {

    $('[data-inline-edit-form="' + id + '"]').toggleClass('hidden');
    $('[data-show-form][data-inline-edit-id="' + id + '"]').toggleClass('hidden')

    if ($('[data-inline-edit-form]:visible').length) {
        $('.inline-edit-save-button').show();
    } else {
        $('.inline-edit-save-button').hide();
    }

}

$(document).on('click', '.inline-edit-save-button', function (e) {
    e.preventDefault();

    var el_submit_button = $(this),
        action = el_submit_button.data('action'),
        form_data = {'_token': el_submit_button.data('csrf')};

    $.each($('[data-inline-edit-form]:visible [name]'), function (input_index, input) {
        form_data[$(input).attr('name')] = $(input).val();
    });

    loadingButton(el_submit_button, 0);

    $.ajax({
        type: 'PUT',
        url: action,
        async: true,
        dataType: "json",
        data: $.param(form_data),
        success: function (response) {

            toastr.success('Güncelleme başarılı.');

            location.reload();

        },
        error: function () {
            toastr.error('Güncelleme esnasında bir hata oluştu lütfen sayfayı yenileyip tekrar deneyiniz.');
        },
        complete: function () {
            loadingButton(el_submit_button, 1);
        }
    });
});
